import * as React from 'react'

function SvgAccessoriesCheckedIcon(props) {
  return (
    <svg
      width={40}
      height={40}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      {...props}
    >
      <path
        d="m32.293 8.293 1.414 1.414L28 15.414l-3.707-3.707 1.414-1.414L28 12.586l4.293-4.293Z"
        fill="#2EC40B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M29 3a8 8 0 1 0 0 16 8 8 0 0 0 0-16Zm-6 8a6 6 0 1 0 12 0 6 6 0 0 0-12 0Z"
        fill="#2EC40B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20 11c0-.26.011-.518.033-.773a3.223 3.223 0 0 0-2.8 1.547L9.68 24.047C8.347 26.212 9.905 29 12.448 29h15.105c2.542 0 4.1-2.788 2.768-4.953l-2.542-4.13a8.94 8.94 0 0 1-2.916-.922l3.754 6.1A1.25 1.25 0 0 1 27.562 27l-6.359-10.447.326-.534a8.969 8.969 0 0 1-1.052-2.12L14.938 23h-2.266l6.264-10.177c.26-.423.71-.62 1.147-.592A9.08 9.08 0 0 1 20 11Zm-8.559 14-.058.095A1.25 1.25 0 0 0 12.448 27H25.22L24 24.995V25H11.441Zm8.592-6.523L22.786 23h-5.507l2.754-4.523Z"
        fill="#000"
      />
    </svg>
  )
}

export default SvgAccessoriesCheckedIcon
